const columnWidths = {
    hr: {
        internalAppId: 80,
        mainPhoto: 80,
        projectStatus: 120,
        projectTitle: 200,
        city: 150,
        widerArea: 150,
        quarter: 150,
        agent: 150,
        contractDate: 150,
        contractNo: 120,
        projectType: 150,
        projectEndDate: 150,
        actions: 100,
    },
    // Add locale overrides below — only specify columns that differ from hr.
    sl: {
        contractNo: 150,
    },
    en: {
        city: 170,
        contractNo: 150,
        projectEndDate: 100,
    },
    de: {},
    it: {},
}

export default columnWidths
